import InlineComponent from './inlineComponent.jsx';
import Field from '../../../components/field/Field.jsx';

module.exports = class TimezoneRenderer extends InlineComponent {
  define() {
    this.data.name = this.data.name.replace('[]', '');

    if (
      (this.element.attr('data-multiple') === 'true' ||
        this.element.attr('data-multiple') === true) &&
      this.data.name.indexOf('[]') == -1
    ) {
      this.data.name = `${this.data.name}[]`;
    }

    this.component = Field;
    this.defaults = {
      required: false,
      multiple: false,
      label: 'Add new value',
      placeholder: '', // HTML's input placeholder
      type: 'text', // Property type, not only HTML's input type
      value: [''], // Value is by default an array but it accepts a string/number too
      outside: true, // Plus and Minus buttons in the outside of the container
      fixed: true, // If true, buttons will be always visible
      references: [], // Array of properties to be referenced. If empty dropdown won't be shown
      metadata: [''], // Property metadata
      semantic: false, // Uses SemanticUI style,
      customNames: {}, // Customization for append, octet, etc... for ip fields
      checkableChannel: false, // If the property is checkable, and it's update channel
      object: '', // Type of object using the property (eg: node, node_group, site)
      objectIdentifier: '', // Unique identifier for the current object
      parentDisabled: false, // Disabled state controled by a parent component
    };
  }
};
